import createAPIRequest from '../helpers/createAPIRequest'
import store from '../store/index'

function normaliseCombatantFatigue(fatigue) {
  if (typeof fatigue !== 'string') {
    return fatigue
  }

  return fatigue.trim().toLowerCase()
}

//------------------
// update combatant
//------------------
export default async function useUpdateCombatant(this_combatant) {
  return new Promise((resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store
    const this_store_state = store.state.combat
    //--------------
    // set arena id
    //--------------
    this_combatant.arena = this_store_state.arena.id
    //-----------------------------
    // normalise combatant fatigue
    //-----------------------------
    if (Object.prototype.hasOwnProperty.call(this_combatant, 'fatigue')) {
      this_combatant.fatigue = normaliseCombatantFatigue(this_combatant.fatigue)
    }
    //--------------------
    // set api call parms
    //--------------------
    let request_parms = {
      endpoint: 'api/v1/combatants/',
      slug: this_combatant.slug,
    }
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms)
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_combatant,
    }
    //--------------------
    // set response parms
    //--------------------
    let response_parms = {
      combatant: null,
      image: null,
    }
    //-----------------------
    // call combatant update
    //-----------------------
    this_store.dispatch('combat/editCombatant', api_parms).then((combatant) => {
      //-------------------
      // set response parm
      //-------------------
      response_parms.combatant = combatant.data
      resolve(response_parms)
    })
  })
}
